import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackEmailChangeVerified.meta';

export type UseTrackEmailChangeVerifiedParams = {
  user_id: string;
  old_email: string;
  new_email: string;
};

export const useTrackEmailChangeVerified = () => {
  const { track } = useAnalyticsUtilities();

  const trackEmailChangeVerified = useCallback(
    (params: UseTrackEmailChangeVerifiedParams) => {
      track(META.name, params, { integrations: { 'Customer.io (Actions)': true } });
    },
    [track],
  );

  return { trackEmailChangeVerified };
};
